
  import * as ipxRuntime$TpOwDPvX1VzediOQTAJ1iVrj_454rwOg1d7ZdR8WJRq3M from '/srv/sarvban_front/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$TpOwDPvX1VzediOQTAJ1iVrj_454rwOg1d7ZdR8WJRq3M, defaults: {} }
    }
  }
